import { Button, Card, Col, Collapse, CollapseProps, Row, Typography } from 'antd'
import React, { useState } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import faqImage from '../../assets/images/svg_img/faq_img.svg'
import image_faq_back from '../../assets/images/txn_left.png'
import image_faq_back_right from '../../assets/images/txn_right.png'
import { useNavigate } from 'react-router-dom';
import '../../components/Home/Questions.scss';

interface FaqItem {
    key: string;
    label: React.ReactNode;
    children: React.ReactNode;
}

interface Props {
    faqData1: FaqItem[];
    faqData2: FaqItem[];
    faqData3: FaqItem[];
    faqData4: FaqItem[];
    faqData5: FaqItem[];
}

const faqData1: FaqItem[] = [
    {
        key: '1',
        label: <Typography style={{ color: 'black', fontSize: '16px', }}> <b>What is Aadhaar authentication?</b></Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px', }}>Aadhaar authentication is the process wherein Aadhaar number, along with other attributes (demographic and/or biometrics and/or OTP) is submitted to UIDAI’s Central Identities Data Repository (CIDR) for verification; the CIDR verifies whether the data submitted matches the data available in CIDR and responds with a “yes/no”. No personal identity information is returned as part of the response.</Typography>,
    },
];

const faqData2: FaqItem[] = [
    {
        key: '2',
        label: <Typography style={{ color: 'black', fontSize: '16px', }}> <b>What are the expected benefits of Aadhaar authentication? How to use Aadhaar authentication as part of service delivery?</b></Typography>,
        children: <div>
            <Typography style={{ textAlignLast: 'left', fontSize: '16px', }}>Some of the expected benefits of Aadhaar authentication are:</Typography>
            <ul><Typography style={{ textAlignLast: 'left', fontSize: '16px', }}>
                <li>Establishing identity for purposes such as adding new beneficiaries, confirming genuine beneficiary before service delivery, attendance management, financial transactions etc.</li>
                <li>Enabling demand-driven, portable service delivery by providing anywhere anytime real-time authentication.</li>
                <li>Access to relevant MIS and empowerment of beneficiary.</li>
                <li>Improving efficiency & transparency in service delivery by enabling tracking of end-to-end service delivery process, improving accountability and vigilance etc.</li>
                <li>Access control to restricted areas such as airports, hotels, high security buildings etc.</li>
                <li>Aadhaar authentication may be used at various points in service delivery when there is a need to authenticate / identify / audit / hold accountable beneficiaries, officials or other members of service delivery / monitoring / audit chain. Illustrative details on how Aadhaar authentication may be integrated in various service delivery programs such as PDS, NREGA, JSY, SSA etc are available in various working papers and presentations developed by UIDAI.</li>
            </Typography></ul>
            {/* </Typography> */}
        </div>
        ,
    },
];

const faqData3: FaqItem[] = [
    {
        key: '3',
        label:
            <Typography style={{ color: 'black', fontSize: '16px', }}> <b>What is ASA (Authentication Service Agency)?</b></Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px', }}>An entity that transmits authentication requests to the CIDR (Central Identities Data Repository) on behalf of one or more AUAs. They should have secure connection with the CIDR and convey AUAs authentication requests to the CIDR and CIDRs response back to the AUA.</Typography>,
    },
];

const faqData4: FaqItem[] = [
    {
        key: '4',
        label: <Typography style={{ color: 'black', fontSize: '16px', }}> <b>What is AUA (Authentication User Agency)?</b></Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px', }}>An organization or an entity using Aadhaar authentication as part of its applications to provide services to residents. Any agency wanting to become an AUA needs to have an agreement with UIDAI directly.</Typography>,
    },
];

const faqData5: FaqItem[] = [
    {
        key: '5',
        label: <Typography style={{ color: 'black', fontSize: '16px', }}> <b>What is Sub AUA?</b></Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px', }}>An organization or a department or an entity having a business relationship with AUA offering specific services in a particular domain.</Typography>,
    },
];
function Questions() {
    const [activeKey, setActiveKey] = useState<string | null>(null);
    const navigate = useNavigate();
    // Combine prefix with key for uniqueness across all collapses
    const getItemsWithPrefixedKeys = (items: FaqItem[], prefix: string): CollapseProps['items'] =>
        items.map((item) => ({
            ...item,
            key: `${prefix}-${item.key}`,
        }));

    const handleChange = (key: string | string[] | null, prefix: string) => {
        let newKey: string | null = null;

        if (Array.isArray(key)) {
            newKey = key[0] || null;
        } else if (typeof key === 'string') {
            newKey = key;
        }

        // Toggle if same key clicked, else open new
        setActiveKey((prevKey) => (prevKey === newKey ? null : newKey));
    };

    const renderCollapse = (data: FaqItem[], prefix: string) => (
        <Collapse 
        style={{ 
            // boxShadow: '0px 0px 7px 0px #0000ff4a', 
            background: 'white' 
        }}
            accordion
            activeKey={activeKey?.startsWith(`${prefix}-`) ? activeKey : undefined}
            onChange={(key) => handleChange(key, prefix)}
            items={getItemsWithPrefixedKeys(data, prefix)}
            expandIcon={({ isActive }) => (
                <div
                    style={{
                        backgroundColor: '#9bcfff',
                        borderRadius: '50%',
                        padding: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '24px',
                        height: '24px',
                    }}
                >
                    <DownOutlined rotate={isActive ? 180 : 0} style={{ color: 'blue' }} />
                </div>
            )}
            expandIconPosition="end"
            
        />
    );

    return (
        <section id="faq" className="faqBlock" style={{ scrollMarginTop: '70px' }}>

            <div className="container-fluid">
                {/* <div className="titleHolder">
                    <h2>Have Questions?</h2>

                </div> */}
                <Row gutter={[16, 16]} style={{ padding: '0px 0px 30px 0px', placeItems: 'center' }}>
                    <Col xl={8} lg={8} md={12} sm={12} xs={24} className="logo-col">
                        <div style={{ textAlign: 'center', position: 'relative', padding: '20px 0', justifyItems: 'start', lineHeight: '1.2' }}>
                            <h3 style={{ margin: '0', color: '#2755ff' }}>FAQ</h3>
                            <h2 style={{ margin: '0', fontSize: '30px', }}>Have Questions?</h2>
                            <h2 style={{ margin: '0', fontSize: '30px', }}>We’ve got answers.</h2>

                        </div>
                        <img style={{ maxWidth: '100%', height: 'auto' }} src={faqImage} alt="faq" className="logo-img" />
                    </Col>
                    <Col xl={16} lg={16} md={12} sm={12} xs={24} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {renderCollapse(faqData1, 'faq1')}
                        {renderCollapse(faqData2, 'faq2')}
                        {renderCollapse(faqData3, 'faq3')}
                        {renderCollapse(faqData4, 'faq4')}
                        {renderCollapse(faqData5, 'faq5')}
                        <button
                            onClick={() => { navigate('/faq'); window.scrollTo(0, 0); }}
                            style={{
                                padding: '10px 24px',
                                marginTop: '-6px',
                                background: 'linear-gradient(135deg, #764ba2 0%, #267ac9ff 100%)',
                                color: 'white',
                                alignSelf: 'flex-start',
                                border: 'none',
                                borderRadius: '25px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 12px rgba(9, 88, 217, 0.3)',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(9, 88, 217, 0.5)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(9, 88, 217, 0.3)';
                            }}
                        >
                            View More
                        </button>
                    </Col>

                </Row>
                <Card
                    style={{
                        position: 'relative',
                        padding: window.innerWidth < 768 ? '0px' : '22px 80px',
                        background: '#0958d9',
                    }}
                >
                    {/* Corner image */}
                    <img
                        src={image_faq_back}
                        alt="corner decoration"
                        style={{
                            position: 'absolute',
                            top: '0px', // or 'top' for top corner
                            left: '0px',  // or 'left' for left corner
                            width: '130px',  // control the size
                            height: 'auto',
                            pointerEvents: 'none', // optional: prevents interfering with clicks
                        }}
                    />
                    {/* <img src={image_faq_back} alt='image' className="corner top-left"/> */}
                    <Row gutter={[16, 16]} align="middle" style={{ position: 'relative', zIndex: 1 }}>
                        <Col xs={24} sm={24} md={14} lg={16} xl={16} style={{ padding: 'clamp(10px, 4vw, 40px)' }}>
                            <Typography style={{ 
                                textAlign: window.innerWidth < 768 ? 'center' : 'start', 
                                fontSize: 'clamp(18px, 4vw, 32px)', 
                                fontWeight: 'bold', 
                                color: '#ffffff',
                                lineHeight: '1.4'
                            }}>
                                Let's discuss how we can help you move forward.
                            </Typography>
                        </Col>

                        <Col xs={24} sm={24} md={10} lg={8} xl={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 'clamp(10px, 3vw, 20px)' }}>
                            <button
                                onClick={() => { navigate('/registrationform'); window.scrollTo(0, 0); }}
                                style={{
                                    padding: 'clamp(10px, 2vw, 12px) clamp(20px, 4vw, 32px)',
                                    height: 'clamp(44px, 10vw, 48px)',
                                    background: 'linear-gradient(135deg, #00ff88 0%, #00d4ff 100%)',
                                    borderRadius: '30px',
                                    fontSize: 'clamp(14px, 2vw, 16px)',
                                    color: '#001a4d',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: '700',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    boxShadow: '0 6px 20px rgba(0, 255, 136, 0.4)',
                                    whiteSpace: 'nowrap',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                    e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 255, 136, 0.6)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 255, 136, 0.4)';
                                }}
                            >
                                Enquire Now
                                <RightOutlined style={{ marginLeft: '8px' }} />
                            </button>
                        </Col>
                    </Row>
                    <img
                        src={image_faq_back_right}
                        alt="corner decoration"
                        style={{
                            position: 'absolute',
                            bottom: '0px', // or 'top' for top corner
                            right: '0px',  // or 'left' for left corner
                            width: '130px',  // control the size
                            height: 'auto',
                            pointerEvents: 'none', // optional: prevents interfering with clicks
                        }}
                    />
                </Card>
            </div>
        </section>
    )
}

export default Questions
